export const preferences = {
  mode: "Mode",
  text: "Text",
  translationFeature: "Translation feature",
  emailUpdates: "Email updates",
  daily: "Daily",
  weekly: "Weekly",
  monthly: "Monthly",
};
